import { useEffect, useState } from "react";
import query from "../../../../../../../server/constants.api";
import useFetch from "../../../../../../../server/useFetch";
import { buildPropertyForModal } from "../../ItemsConfig/ItemsConfig";
import ItemCreateEditModal from "../ItemCreateEditModal/ItemCreateEditModal";

const ItemEdit = ({ isModelOpen, record, onCloseModal }) => {

    const [itemToPut, setItemToPut] = useState(null);

    const {
        data: editItemData,
        isFetching: editItemIsFetching,
        error: editItemError,
        isSuccess: editItemIsSuccess,
        isError: editItemIsError,
        refetch: editItemRefetch,
        remove: removeEditItem
    } = useFetch(
        '/items',
        'editItem',
        itemToPut,
        false,
        'PUT',
        query.middlewareURL);

    useEffect(() => {
        if (itemToPut && !editItemIsFetching) {
            editItemRefetch();
        }
    }, [itemToPut]);

    const updateItemToPut = (newItemData) => {
        setItemToPut(newItemData);
    }

    /**
     * Serialize the record to be shown in the modal
     * @param {*} recordToSerialize 
     * @returns 
     */
    const serializeRecord = (recordToSerialize) => {
        if (!recordToSerialize || !isModelOpen) return null;

        const recordSerialized = {
            mandatoryProperties: [],
            optionalProperties: [],
            itemId: recordToSerialize.itemId,
        }

        const recordCopy = {
            mandatoryProperties: [...recordToSerialize.mandatoryProperties],
            optionalProperties: [...recordToSerialize.optionalProperties],
        };

        recordCopy.mandatoryProperties?.forEach(property => {
            const newProperty = buildPropertyForModal(property, true, true);
            recordSerialized.mandatoryProperties.push(newProperty);
        });

        recordCopy.optionalProperties?.forEach(property => {
            const newProperty = buildPropertyForModal(property, true);
            recordSerialized.optionalProperties.push(newProperty);
        });
        return recordSerialized;

    }

    return (
        <ItemCreateEditModal
            isModelOpen={isModelOpen}
            record={serializeRecord(record)}
            onCloseModal={onCloseModal}
            setItemData={updateItemToPut}
            isToEdit={true}
            removeFetch={removeEditItem}
            isFetching={editItemIsFetching}
            isSuccess={editItemIsSuccess}
            isError={editItemIsError}
            error={editItemError}
        />
    )
}

export default ItemEdit;